import React, {FormEventHandler, useEffect, useState} from "react";
import { CircularProgress, makeStyles, Paper, Typography } from "@material-ui/core";
import { Button, Grid, Box } from '@material-ui/core';
import { SettingsType, useSettingsGet } from '../hooks/useSettingsGet';
import { useSettingsSet } from '../hooks/useSettingsSet';
import { useDispatch } from 'react-redux';
import { flashActions } from '../data-management/flashSlice';
import { useToken } from '../hooks/useToken';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import 'react-quill/dist/quill.snow.css'; // ES6
import { useRouteMatch } from "react-router-dom";
import { useProductCategoryDescriptionSet } from "../hooks/useProductCategoryDescriptionSet";
const ReactQuill = require('react-quill');

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  gap: {
    marginTop: theme.spacing(2),
    textAlign: 'end',
  },
}));


export const EditProductCategory = () => {

  const { params: { id }, } = useRouteMatch<{
    id: string | undefined;
  }>();

  const classes = useStyles();
  const [description, setDescription] = useState<any>("");
  const [category, setCategory] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const token = useToken();
  const descriptionSetApi = useProductCategoryDescriptionSet(id);
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    if(id){
      axios.get(
        `${process.env.REACT_APP_SERVER_URL}/categories/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      ).then((res) => {
        setDescription(res.data.description);
        setCategory(res.data);
        setLoading(false);
      })
    }
  }, []);

  const handleSubmit:FormEventHandler<Element> = (e) => {
    e.preventDefault();

    descriptionSetApi(description).then(() => {
      dispatch(flashActions.addFlashMessage('Termék kategória leírás módosítása sikeres!'));
    }).catch(()=>{
      dispatch(flashActions.addFlashMessage('Termék kategória leírás módosítása sikertelen!'))
    })
  }
  

  return (
    <Paper>
    {loading 
    ? <Grid container justify={'center'}><Box p={2}><CircularProgress/></Box></Grid> 
    :<div className={classes.root}>
      <Typography className="" variant="h4">
        {category?.name}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Box className={classes.gap}>
          <Button type="submit" variant="contained" color="primary">
            Mentés
          </Button>
        </Box>
        <ReactQuill value={description || ""} onChange={(changed : any)=>{setDescription(changed)}} />
      </form>
    </div>}
    </Paper>
  );
}